
// import ExternalConfiguration from '../../external-configuration';

import Content, * as ContentConstants from '../Content';

import Media from './Media';

const Bradmax_player_Configuration = {

  processConfiguration: (loadedConfiguration = {}) => {
  
    const { singleMedia, playlist = [], mainWithBackups, balancedFallbacks, multiChannel, contentType, errorMedia } = Content.processConfiguration( loadedConfiguration, Media.processMedia);

    const contentData = {
      singleMedia,
      contentType,
      mainWithBackups,
      balancedFallbacks,
      multiChannel,
      errorMedia,
    };

    return { bradmax_playerConfiguration: {}, contentData, auxiliarData: {} };
  },

};

export default Bradmax_player_Configuration;
